// extracted by mini-css-extract-plugin
export default {"topDropdownOptionDiv":"HousingComponent_topDropdownOptionDiv__Hwk5G"};